import { Button } from '@tempo-io/sui-button';
import { useTranslation } from 'react-i18next';

export const TimelineSelectionActionBar = ({
  count,
  onClear,
}: {
  count: number;
  onClear: () => void;
}) => {
  const { t } = useTranslation();
  if (count === 0) return null;

  return (
    <div
      data-no-rubber-band
      className="absolute bottom-4 left-1/2 -translate-x-1/2 z-20 flex items-center gap-3 px-4 py-2 bg-bg-surface-base border-2 rounded-full shadow-lg"
    >
      <span className="text-sm font-medium text-text-neutral-primary">
        {count} {t(($) => $.common.selected)}
      </span>
      <Button variant="ghost" size="sm" onClick={onClear}>
        {t(($) => $.common.clearSelection)}
      </Button>
    </div>
  );
};
